import React from 'react';

import Icon from 'app/components/common/icon';

class PageHome extends React.PureComponent {

  render() {
    return (
      <div className="tyler">
        <h1 className="tyler-h1">Tyler Brown, Software Engineer</h1>
        <p className="tyler-desc">Staff-level engineer with 15+ years of experience building full-stack and universal JavaScript web apps.</p>
        <ul className="tyler-links">
          <li><a href="/tyler-brown-resume-2025.pdf">Résumé <Icon.Caret direction="right" /></a></li>
          <li><a href="https://www.linkedin.com/in/tybro0103/">LinkedIn <Icon.Caret direction="right" /></a></li>
          <li><a href="https://github.com/tybro0103">GitHub <Icon.Caret direction="right" /></a></li>
          <li><a href="https://stackoverflow.com/users/202875/tybro0103">StackOverflow <Icon.Caret direction="right" /></a></li>
        </ul>
      </div>
    );
  }

}

export default PageHome;
